import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaXmark } from "react-icons/fa6";
import Button from "@components/forms/Button/Button";
import SearchItemModal from "@components/modals/SearchItemModal/SearchItemModal";
import './SearchItem.scss';

type SearchItemType = {
    id: number,
    label: string,
    description: string,
};

type SearchItemProps = {
    className?: string,
    label: string,
    values: Array<SearchItemType>,
    path: string,
    multiple?: boolean,
    btnSearchText?: string,
    searchPlaceholder?: string,
    onChange: (values: Array<SearchItemType>) => void,
};

function SearchItem(props: SearchItemProps) {
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [values, setValues] = useState<Array<SearchItemType>>([]);

    const { t } = useTranslation();

    const handleDelete = (item: SearchItemType) => {
        
    };

    const handleAdd = (item: SearchItemType) => {
        let updatedValues: Array<SearchItemType> = [];

        if(props.multiple) {
            updatedValues = [
                ...values,
                item,
            ];
        }
        else {
            updatedValues = [item];
        }

        setValues(updatedValues);
        props.onChange(updatedValues);
    };

    useEffect(() => {
        setValues(props.values);
    }, [props.values]);

    return (
        <div className="searchitem">
            <span className="searchitem-label">{props.label}</span>
            <ul className="input-list">
                {values.map((item: SearchItemType, index: number) => (
                    <li key={index}>
                        <span className="label">{item.label}</span>
                        {props.multiple && (
                            <div className="actions">
                                <span onClick={() => handleDelete(item)}><FaXmark/></span>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
            <div className="row g-1 align-items-center">
                <Button size="sm" filled onClick={() => setModalVisible(true)}>{props.btnSearchText ?? t('text.search')}</Button>
            </div>

            <SearchItemModal visible={modalVisible} path={props.path} inputPlaceholder={props.searchPlaceholder} onHide={() => setModalVisible(false)} onSelect={handleAdd}/>
        </div>
    );
}

export type {
    SearchItemType,
};
export default SearchItem;
